export default __webpack_public_path__ + "static/media/Professional-Readme.b3f7bc19.png";